import { sheet } from '../lib/ui.js';
import { AccountSheet } from './AccountSheet.js';
import { AdjustSheet } from './AdjustSheet.js';
import { EntrySheet } from './EntrySheet.js';
import { ItemSheet } from './ItemSheet.js';
import { MoneySheet } from './MoneySheet.js';
import { PartySheet } from './PartySheet.js';
import { PaymentSheet } from './PaymentSheet.js';
import { ReturnSheet } from './ReturnSheet.js';
import { TransferSheet } from './TransferSheet.js';
import { TxSheet } from './TxSheet.js';
import { UserSheet } from './UserSheet.js';

export function SheetHost() {
  const s = sheet.value;
  if (!s) return null;
  // key forces a fresh form each time a sheet opens
  const key = JSON.stringify(s);
  switch (s.kind) {
    case 'sale':
    case 'purchase':
      return <TxSheet key={key} kind={s.kind} partyId={s.partyId} />;
    case 'item':
      return <ItemSheet key={key} id={s.id} />;
    case 'party':
      return <PartySheet key={key} id={s.id} type={s.type} />;
    case 'payment':
      return (
        <PaymentSheet key={key} direction={s.direction} partyId={s.partyId} amount={s.amount} />
      );
    case 'return':
      return <ReturnSheet key={key} itemId={s.itemId} />;
    case 'expense':
    case 'drawing':
      return <MoneySheet key={key} kind={s.kind} />;
    case 'transfer':
      return <TransferSheet key={key} />;
    case 'account':
      return <AccountSheet key={key} id={s.id} />;
    case 'user':
      return <UserSheet key={key} id={s.id} />;
    case 'adjust':
      return <AdjustSheet key={key} itemId={s.itemId} bin={s.bin} />;
    case 'entry':
      return <EntrySheet key={key} id={s.id} />;
  }
}
